import { combineReducers } from 'redux';
import { createSequoiaResource } from '@gandi/resource/redux';
const baseResource = createSequoiaResource('authz', 'entities', {
  statePath: 'acl.entities'
});
export function getFetchParams(identifier) {
  return typeof identifier === 'string' ? {
    entityId: identifier
  } : {
    type: identifier.type,
    name: identifier.name
  };
}
function generateFetchOnePath(fetchParams) {
  return typeof fetchParams?.type === 'string' ? 'orgread/authz/entities/{type}/{name}' : 'orgread/authz/entities/{entityId}';
}
function computeLabel(path, fetchParams) {
  return baseResource.computeLabel(generateFetchOnePath(fetchParams), fetchParams);
}
function fetchOne(url, fetchOptions) {
  const fetchUrl = generateFetchOnePath(fetchOptions?.params);
  return baseResource.fetchOne(fetchUrl, {
    ...fetchOptions,
    params: fetchOptions?.params
  });
}
fetchOne.failure = baseResource.fetchOne.failure;
fetchOne.start = baseResource.fetchOne.start;
fetchOne.success = baseResource.fetchOne.success;
export const createHasPermissions = resource => permissions => {
  if (resource.isForbidden) {
    return false;
  }
  if (!resource.detail || resource.isFailure || resource.detail.permissions.includes('*')) {
    return true;
  }
  return permissions.every(permission => resource.detail?.permissions.includes(permission));
};
const getEntityPermissions = identifier => async (dispatch, getState) => {
  const params = getFetchParams(identifier);
  const label = computeLabel('<unused>', params);
  await dispatch(fetchOne('<unused>', {
    params,
    label
  }));
  const detail = baseResource.selectDetail(getState(), label);
  const isFailure = baseResource.selectIsFailureOne(getState(), label);
  const isFetching = baseResource.selectIsFetchingOne(getState(), label);
  const isForbidden = baseResource.selectIsFailureOne(getState(), {
    label,
    status: 403
  });
  const isLoaded = baseResource.selectIsLoadedOne(getState(), label);
  const isNotFound = baseResource.selectIsFailureOne(getState(), {
    label,
    status: 404
  });
  const shouldFetch = baseResource.selectShouldFetchOne(getState(), label);
  const hasPermissions = createHasPermissions({
    detail,
    label,
    isFailure,
    isFetching,
    isForbidden,
    isLoaded,
    isNotFound,
    shouldFetch
  });
  return {
    hasPermissions,
    isFailurePermissions: isFailure,
    isFetchingPermissions: isFetching,
    isForbiddenPermissions: isForbidden,
    isLoadedPermissions: isLoaded,
    isNotFoundPermissions: isNotFound,
    shouldFetchPermissions: shouldFetch
  };
};
function computeEntityLabel(identifier) {
  const params = getFetchParams(identifier);
  return computeLabel('<unused>', params);
}
export const entitiesResource = {
  ...baseResource,
  computeLabel,
  fetchOne,
  getEntityPermissions,
  computeEntityLabel
};
export const reducer = combineReducers({
  ...entitiesResource.detailReducer
});